exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999999;\n  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#eb5d46+0,eb5d46+50,1a1935+51,1a1935+100 */\n  background: #000000;\n  /* Old browsers */\n  /* FF3.6-15 */\n  /* Chrome10-25,Safari5.1-6 */\n  background: linear-gradient(to bottom, #3a3937 0%, #3a3937 50.5%, #000000 50.51%, #000000 100%);\n  /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#3a3937', endColorstr='#000000',GradientType=0 );\n  /* IE6-9 */ }\n  .loading-overlay img {\n    position: absolute;\n    height: 50%;\n    width: auto;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/app.component.scss
// module id = ../../../../../resources/assets/src/app/app.component.scss
// module chunks = main